import React from 'react';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import { DATE_FORMAT } from '../../../constants/constants';
import './DatePicker.scss';
import Icon from '../Icon';

interface DatePickerWrapperProps {
	value: string;
	name: string;
	label: string;
	onChange: (dateString: string, name: string) => void;
	className?: string;
	isRequired?: boolean;
	errorMessage?: string;
	isDisabled?: boolean;
}

const DatePickerWrapper: React.FC<DatePickerWrapperProps> = ({
	value,
	name,
	label,
	onChange,
	className = '',
	isRequired = false,
	errorMessage = '',
	isDisabled = false,
}) => {
	const parseDate = (dateString: string): Date | null => (dateString ? moment(dateString, DATE_FORMAT).toDate() : null);

	const handleChange = (date: Date | null) => {
		if (!date) {
			onChange('', name);
			return;
		}
		const utcDate = moment(date).utc(true);
		onChange(utcDate.format(DATE_FORMAT), name);
	};

	const invalidClass = isRequired && value.trim().length === 0 ? 'invalid' : '';

	// Custom input field with icon
	const CustomInput = React.forwardRef<HTMLInputElement, React.HTMLProps<HTMLInputElement>>(({ value, onClick }, ref) => (
		<div className='react-datepicker__input-container' onClick={onClick}>
			<input type='text' value={value} readOnly ref={ref} className='custom-input' />
			<Icon name='calendar-alt' className='calendar-icon' />
		</div>
	));
	CustomInput.displayName = 'CustomInput';

	return (
		<div className={`date-picker-container ${invalidClass} ${className} mb-3`}>
			<span className='has-float-label custom-datepicker-container'>
				<DatePicker
					showIcon
					name={name}
					selected={parseDate(value)}
					onChange={handleChange}
					dateFormat='d MMM yyyy'
					placeholderText={label}
					disabled={isDisabled}
					required={isRequired}
					dropdownMode='select'
					portalId='root'
					customInput={<CustomInput />}
				/>
				<label htmlFor={name}>{label}</label>
				{invalidClass && <div className='invalid-feedback'>{errorMessage}</div>}
			</span>
		</div>
	);
};

export default DatePickerWrapper;
